import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el material?',
  a: 'Inmediatamente después de confirmar el pago recibís un mail con el acceso a todos los archivos PDF. En menos de 5 minutos tenés todo descargado en tu celular, tablet o computadora.'
}, {
  q: '¿Sirve si soy profe nueva o si tengo experiencia?',
  a: 'Sí para las dos. Si sos nueva: tenés una estructura pedagógica completa que te evita años de prueba y error. Si tenés experiencia: tenés un sistema que organiza y potencia todo lo que ya sabés hacer.'
}, {
  q: '¿Los 6 Bonus están en las dos opciones?',
  a: 'Sí. Los 6 Bonus están incluidos en el Pack Profesional ($18.990) y en el Megapack Elite ($27.990). La diferencia del Elite son los 2 Ebooks adicionales: El Mapa de Ruta Anual y Muestras Sin Caos.'
}, {
  q: '¿Qué diferencia hay con otros materiales que ya existen?',
  a: 'La mayoría de los materiales son ideas sueltas o actividades sin progresión. Danza Infantil 360 es un sistema de 3 años con objetivos semanales claros, ejercicios graficados y una lógica pedagógica que conecta cada clase con la siguiente. No es un libro de juegos: es una arquitectura completa de enseñanza.'
}, {
  q: '¿Sirve para distintas edades mezcladas en el mismo grupo?',
  a: 'Sí. El sistema está dividido en 3 Ciclos (A: 3-4 años, B: 5-6 años, C: 7-8 años) con criterios claros de transición entre niveles. La guía de implementación del Elite 1 te explica cómo manejar grupos mixtos sin perder la progresión.'
}, {
  q: '¿Qué pasa si no me sirve?',
  a: 'Tenés 7 días de garantía total. Si abrís el material y no es lo que esperabas, escribís a nuestro mail y te devolvemos el 100% sin preguntas.'
}, {
  q: '¿Vale la pena el Megapack Elite si ya planifico bien mis clases?',
  a: 'Si ya planificás bien, el Elite 1 (Mapa de Ruta) te ahorra entre 3 y 5 horas semanales conectando los 12 Tomos en un plan automático. Y el Elite 2 (Muestras Sin Caos) te da el sistema para que la muestra de fin de año sea tu mejor carta de presentación frente a los padres. Si ya planificás bien, con el Elite planificás mejor en menos tiempo.'
}, {
  q: '¿Puedo pagar con tarjeta de crédito?',
  a: 'Sí. Aceptamos todas las tarjetas de crédito y débito, y transferencia bancaria. El pago es 100% seguro a través de Mercado Pago.'
}];
export function FAQSection() {
  return <section className="py-20 bg-cream-50" data-id="element-81">
      <div className="max-w-3xl mx-auto px-4" data-id="element-82">
        <h2 className="font-serif text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-83">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-84">
          {faqs.map((faq, idx) => <FAQItem key={idx} question={faq.q} answer={faq.a} data-id="element-85" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-cream-200 rounded-2xl overflow-hidden bg-white shadow-sm" data-id="element-86">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none hover:bg-cream-50 transition-colors" aria-expanded={isOpen} data-id="element-87">
        <span className={`font-bold pr-4 transition-colors ${isOpen ? 'text-wine-700' : 'text-gray-900'}`} data-id="element-88">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180 text-wine-700' : 'text-gray-400'}`} data-id="element-89" />
      </button>
      <AnimatePresence data-id="element-90">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-91">
            <div className="px-6 pb-5 text-gray-700 leading-relaxed border-t border-cream-100 pt-4" data-id="element-92">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}